import React from "react";
import { Card, MenuItem } from "@mui/material";
import moment from "moment";

import { isActiveBusinessArea } from "views/pages/manage/unAssigned/collectPayment/utils.jsx";

const TableMenuActions = ({
  handleClose,
  menuItems = [],
  rowData,
  isCentralizedAdm,
}) => {
  return (
    <Card style={{ padding: "0.7rem 0.4rem" }}>
      {menuItems.map(({ icon, text, handleClick , isDisabled = () => {} }, index) => {
        return (
          <MenuItem
            className="d-flex py-2 text-sm"
            style={{ gap: "16px", fontWeight: 700 }}
            onClick={() => {
              handleClick(rowData);
              handleClose();
            }}
            key={index}
            disabled={
              !rowData.receiptId ||
              !rowData.receiptId.trim() ||
              (index == 1
                ? isCentralizedAdm ||
                  !isActiveBusinessArea({ buLabel: rowData.businessArea }) ||
                  !moment(rowData?.receiptDate).isSame(moment(), "day")
                : false) ||
              isDisabled(rowData)  
              //   ||
              // (index === 2
              //   ? !isActiveBusinessArea({ buLabel: rowData.businessArea })
              //   : false)
            }
          >
            {icon}
            <span>{text}</span>
          </MenuItem>
        );
      })}
    </Card>
  );
};

export default TableMenuActions;
